// @flow
import React, { Component } from 'react';
import _ from 'underscore';
import { hashHistory, IndexRedirect, Route, Router } from 'react-router';

import NotFoundPage from './NotFoundPage';
import * as ga from '../util/tracking/GoogleAnalytics';
import { updateInlineManualPlayer } from '../util/InlineManual';
import { resetAppcues } from '../util/tracking/Appcues';
import AdminPortalRootPage from './AdminPortalRootPage';

export const ACCOUNT_DETAILS = 'accountDetails';
export const ACCOUNT_USERS_PATH = 'accountUsers';
export const ADMIN_PATH = 'admin';

const onChangePage = _.debounce(() => {
  ga.pageView(window.location.hash);
  resetAppcues();
  updateInlineManualPlayer();
}, 300);

export default class AdminRouter extends Component {
  render() {
    return (
      <Router history={hashHistory} onUpdate={onChangePage}>
        <Route path="/">
          <IndexRedirect to={ADMIN_PATH}/>
          <Route component={(props) => (
            <AdminPortalRootPage {...props} featureFlags={this.props.featureFlags} />
          )} path={ADMIN_PATH}>
            <IndexRedirect to={ACCOUNT_USERS_PATH}/>
            <Route path=":view"/>
          </Route>
        </Route>
        {/* This route must be last */}
        <Route component={NotFoundPage} path="*"/>
      </Router>
    );
  }
}